module.exports = __webpack_public_path__ + "img/album23_07.ea55afe3.jpg";